// extracted by mini-css-extract-plugin
export default {"link":"Source_link__a9Q7U","icon":"Source_icon__SAj5x"};